"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleProductCard = SimpleProductCard;
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _index = require("../../fuse-price/src/index");
var _productImage = require("../../fuse-product-image/src/product-image");
var _typography = require("../../fuse-typography-element/src/typography");
var _config = _interopRequireDefault(require("./config"));
var _simpleSkeletonCard = _interopRequireDefault(require("./simple-skeleton-card"));
var _styledSimpleProductCard = _interopRequireDefault(require("./styled-simple-product-card"));
var _excluded = ["title", "brand", "imgUrl", "imgAltText", "prodUrl", "price", "prevPrice", "priceSaving", "showSave", "showCurrentPriceFrom", "showPreviousPriceFrom", "isEuro", "isSkeleton"]; // import ProductImage from './simple-product-image';
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var propTypes = {
  title: _propTypes["default"].string,
  brand: _propTypes["default"].string,
  imgUrl: _propTypes["default"].string,
  imgAltText: _propTypes["default"].string,
  prodUrl: _propTypes["default"].string,
  price: _propTypes["default"].number,
  prevPrice: _propTypes["default"].number,
  priceSaving: _propTypes["default"].number,
  showCurrentPriceFrom: _propTypes["default"].bool,
  showPreviousPriceFrom: _propTypes["default"].bool,
  showSave: _propTypes["default"].bool,
  isEuro: _propTypes["default"].bool,
  isSkeleton: _propTypes["default"].bool
};
var defaultProps = {
  title: "",
  brand: "",
  imgUrl: undefined,
  imgAltText: undefined,
  prodUrl: "#",
  showCurrentPriceFrom: false,
  showPreviousPriceFrom: false,
  showSave: true,
  isEuro: false,
  price: 0,
  prevPrice: 0,
  priceSaving: 0,
  isSkeleton: false
};
var BrandContainer = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  displayName: "simple-product-card__BrandContainer",
  componentId: "sc-p9m4tg-0"
})(["margin:0 0 var(--spacing-global-space2) 0;min-height:calc(var(--font-size-1) + 4px);display:block;max-width:100%;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"]);
var TitleContainer = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  displayName: "simple-product-card__TitleContainer",
  componentId: "sc-p9m4tg-1"
})(["display:block;margin:0 0 var(--spacing-global-space3);overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"]);
var StyledProductImage = (0, _styledComponents["default"])(_productImage.ProductImage).withConfig({
  displayName: "simple-product-card__StyledProductImage",
  componentId: "sc-p9m4tg-2"
})(["margin-bottom:var(--spacing-global-space4);"]);
var isAltExists = function isAltExists(text) {
  return (typeof text === 'string' || text instanceof String) && text.length > 1;
};
function SimpleProductCard(_ref) {
  var title = _ref.title,
    brand = _ref.brand,
    imgUrl = _ref.imgUrl,
    imgAltText = _ref.imgAltText,
    prodUrl = _ref.prodUrl,
    price = _ref.price,
    prevPrice = _ref.prevPrice,
    priceSaving = _ref.priceSaving,
    showSave = _ref.showSave,
    showCurrentPriceFrom = _ref.showCurrentPriceFrom,
    showPreviousPriceFrom = _ref.showPreviousPriceFrom,
    isEuro = _ref.isEuro,
    isSkeleton = _ref.isSkeleton,
    props = _objectWithoutProperties(_ref, _excluded);
  var isAltUnreal = !isAltExists(imgAltText);
  var imgAlt = isAltUnreal ? "Missing image for: ".concat(title) : imgAltText;
  return isSkeleton ? /*#__PURE__*/_react["default"].createElement(_simpleSkeletonCard["default"], _extends({
    className: "fuse-product-card"
  }, props)) : /*#__PURE__*/_react["default"].createElement(_styledSimpleProductCard["default"], _extends({
    className: "fuse-product-card",
    href: prodUrl
  }, props), /*#__PURE__*/_react["default"].createElement(StyledProductImage, {
    alt: imgAlt,
    src: imgUrl,
    lazy: true,
    isAltReal: isAltUnreal,
    sources: _config["default"],
    border: "var(--border-width-xs) solid var(--color-global-grey300)"
  }), /*#__PURE__*/_react["default"].createElement(BrandContainer, {
    type: "paragraph",
    size: "m1",
    tag: "span",
    className: "fuse-product-card__brand",
    "data-testid": "product-card__brand"
  }, brand), /*#__PURE__*/_react["default"].createElement(TitleContainer, {
    type: "heading",
    size: "m1",
    tag: "h3",
    className: "fuse-product-card__title",
    "data-testid": "product-card__title"
  }, title), /*#__PURE__*/_react["default"].createElement(_index.Price, {
    className: "fuse-product-card__price",
    headingTag: "h4",
    isEuro: isEuro,
    prevPrice: (0, _fuseUtils.formatPrice)(prevPrice),
    price: (0, _fuseUtils.formatPrice)(price),
    saving: priceSaving,
    showCurrentFrom: showCurrentPriceFrom,
    showPreviousFrom: showPreviousPriceFrom,
    showSave: showSave,
    size: "s",
    "data-testid": "product-card__price"
  }));
}
SimpleProductCard.propTypes = propTypes;
SimpleProductCard.defaultProps = defaultProps;
var _default = exports["default"] = SimpleProductCard;